import { render, staticRenderFns } from "./PreviewNotice.vue?vue&type=template&id=0db9d40b&scoped=true"
import script from "./PreviewNotice.vue?vue&type=script&lang=js"
export * from "./PreviewNotice.vue?vue&type=script&lang=js"
import style0 from "./PreviewNotice.vue?vue&type=style&index=0&id=0db9d40b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db9d40b",
  null
  
)

export default component.exports